import { DateService } from './../../services/date.service';
import { AdminService } from './../../services/admin.service';
import { Component, ElementRef, Injectable, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { ApiService } from 'src/app/services/api.service';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';
  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class EmployeeDetailsComponent implements OnInit {
  @ViewChild('contentActivation', { static: false }) content: ElementRef;
  @ViewChild('contentPriviledge', { static: false })
  contentPriviledge: ElementRef;
  meetingNav: { index: string; name: string; link: string }[];
  activation: boolean = true;
  priviledge: boolean = true;
  selectAll: boolean = false;
  entryGate: any = [];
  meetingRoomAccess: any = [];
  deskAccess: any = [];
  privateSuiteAccess: any = [];
  closeResult: string;
  employeeDetails;
  acronym: any;
  url: string;
  accessPointList: any;
  accessPointListName: any;
  accessPointChanged = [];
  useraccessPointChanged = [];
  userInfo: any;
  deptInfo: any;
  token: string;
  accessFromDate: any;
  accessToDate: any;
  creditFromDate: any;
  creditToDate: any;
  meetingFromDate: any;
  meetingToDate: any;
  creditFromDateErr: boolean = false;
  creditToDateErr: boolean = false;
  accessFromDateErr: boolean = false;
  accessToDateErr: boolean = false;
  meetingFromDateErr: boolean = false;
  meetingToDateErr: boolean = false;
  tenantId = localStorage.getItem(AppConstant.localStorage.tenantId);
  statusText: string;
  constructor(
    private modalService: NgbModal,
    private router: Router,
    private apiService: ApiService,
    private appStateSrv: AppStateProvider,
    private adminSrv: AdminService,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv:DateService,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,

  ) {
    ngbDatepickerConfig.minDate = {
      year: 1970, month: 1, day: 1
    };

    ngbDatepickerConfig.outsideDays = 'visible';
   }
  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  ngOnInit(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.getApiauthorizationToken();

    console.log('this.employeeDetails', this.employeeDetails);

    this.meetingNav = [
      {
        index: '1',
        name: 'Employees',
        link: '/employees/employees-list/employee-details',
      },
    ];

    const route = {
      index: '1',
      name: 'Employees',
      link: '/employees/employees-list/employee-details',
    };
    this.appStateSrv.setSideNavState(route);
  }
  getEmployeeDetails() {
    this.url = APIs.getUserInfo;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember),
    };
    this.apiService.get(this.url, param).subscribe({
      next: (response: any) => {
        this.employeeDetails = response.data;
        console.log('employeeDetails', this.employeeDetails);
        this.activation = this.employeeDetails.t0200OrgEmployees[0].isActive;
        this.priviledge = this.employeeDetails.isPriviledge;
        this.getName();
        this.getDepartmentDetails();
        this.getAccessPointList();
      },
      error: (err) => console.log('error', err)
    });
  }
  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    // if (localStorage.getItem(AppConstant.localStorage.token) != null) {
    //   if (this.dataService.employeeDetails.value != null) {
    //     this.dataService.employeeDetails.subscribe((response) => {
    //       this.employeeDetails = response.data.m0200Users[0];
    //       this.deptInfo = response;
    //       this.getName();
    //     })
    //   }
    //   else {
    //   }
    this.getEmployeeDetails();

    // }
    //});
  }
  getDepartmentDetails() {
    this.url = APIs.getUserDepartmentInfo;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember),
    };
    this.apiService.get(this.url, param).subscribe({
      next: (response: any) => {
        this.deptInfo = response;
        // this.dataService.employeeDetails.next(this.deptInfo)
      },
      error: (err) => console.log('error', err)
    });
  }
  getUserAccessPointList() {
    this.url = APIs.getUserAccessPoints;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember),
    };
    this.apiService.get(this.url, param).subscribe({
      next: (response: any) => {
        this.accessPointList = response;
        this.setAccessPoint();
        console.log('accessPointList', this.accessPointList);
      },
      error: (err) => console.log('error', err)
    });
  }
  getAccessPointList() {
    this.url = APIs.getTenantSavedAccessPoints;
    const param = {
      TenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    };
    this.apiService.get(this.url, param).subscribe({
      next: (response: any) => {
        this.accessPointListName = response;
        this.getUserAccessPointList();
        console.log('accessPointListName', this.accessPointListName);
      },
      error: (err) => console.log('error', err)
    });
  }
  setAccessPoint() {
    if (this.accessPointList.list.length === this.accessPointListName.list.length) {
      this.selectAll = true
    }
    else {
      this.selectAll = false
    }
    console.log('this.accessPointList[0]', this.accessPointList);
    let modifiedAccessPoints: any = { ...this.accessPointListName };
    if (this.accessPointList.list.length > 0) {

      modifiedAccessPoints.list = modifiedAccessPoints.list.map(
        (accesspoints) => {
          this.accessPointList.list.forEach((acc) => {
            if (acc.accessPointId == accesspoints.accessPointId)
              accesspoints['selected'] = true;
          });
          return accesspoints;
        }
      );

      console.log('modifiedAccessPoints', modifiedAccessPoints);

      this.entryGate = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'entry_gate')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          return access;
        });



      this.meetingRoomAccess = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'meeting_room')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          return access;
        });

      this.privateSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'team_room')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          return access;
        });

      this.deskAccess = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'desk')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          return access;
        });

    } else {
      this.entryGate = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'entry_gate')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          access['selected'] = false;
          return access;
        });
      this.meetingRoomAccess = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'meeting_room')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          access['selected'] = false;
          return access;
        });
      this.privateSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'team_room')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          access['selected'] = false;
          return access;
        });
      this.deskAccess = modifiedAccessPoints.list
        .filter((access) => access.accessPoint.type === 'desk')
        .map((access) => {
          access['label'] = access.accessPoint.accessPointName;
          access['selected'] = false;
          return access;
        });
    }

    // this.accessPointList.list.forEach((data) => {

    //   if (data.type == 'entry_gate') {
    //     console.log("data", data)
    //     const lbl = this.accessPointListName.list.filter((item) => item.id === data.accessPointId);
    //     data.label = lbl[0].accessPointName;
    //     data.selected = true;
    //     this.entryGate.push(data);
    //   }
    //   else if (data.type == 'meeting_room') {
    //     const lbl = this.accessPointListName.list.filter((item) => item.id === data.accessPointId);
    //     data.label = lbl[0].accessPointName;
    //     data.selected = true;
    //     this.meetingRoomAccess.push(data);
    //   }
    //   else if (data.type == 'team_room') {
    //     const lbl = this.accessPointListName.list.filter((item) => item.id === data.accessPointId);
    //     data.label = lbl[0].accessPointName;
    //     data.selected = true;
    //     this.privateSuiteAccess.push(data);
    //   }
    //   else if (data.type == 'desk') {
    //     const lbl = this.accessPointListName.list.filter((item) => item.id === data.accessPointId);
    //     data.label = lbl[0].accessPointName;
    //     data.selected = true;
    //     this.deskAccess.push(data);
    //   }

    // })
    console.log('this.entryGtae', this.entryGate);
    // })
  }
  getName() {
    var str = this.employeeDetails.userName;
    // var str = this.userInfo.UserName;
    // var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    // this.acronym = matches.join(''); // JSON
    this.acronym = this.generateInitials(str);

    console.log('this.acronym', this.acronym);
  }

  generateInitials(fullName: string): string {
    if (fullName !== '' && fullName !== null && fullName !== undefined)
      return (
        fullName.split(' ')[0].charAt(0).toUpperCase() +
        ' ' +
        (fullName.split(' ')[1] === undefined || fullName.split(' ')[1] === null
          ? ''
          : fullName.split(' ')[1].charAt(0).toUpperCase())
      );
    else return '';
  }

  updateUserAccessPoint(list = this.useraccessPointChanged) {
    const data = {
      accessPointList: list,
      sendEmail: true,
      userId: Number(localStorage.getItem(AppConstant.localStorage.selectedMember)),
      AccessOperationType: list[0].hasAccess
    };
    this.apiService
      .post(APIs.updateMemberAccessPoint, data, '')
      .subscribe((result) => {
        console.log('result1', result);
        window.location.reload();
      });

    // return this.apiService.post(APIs.addemployee, data).pipe(map(response => {
    //   return response;
    // }));
  }
  changeAccess(eg, module, i, updateType: string = 'single') {
    if (!this.activation) {
      return;
    }
    let data = eg;
    this.useraccessPointChanged = [];
    if (!data.isCLAModified) {
      if (module == 'entryGate') {
        let index = this.entryGate.indexOf(data);
        let selected = !data.selected;
       // data = eg.accessPoint;
        this.entryGate[index] = data;
        if (selected == true) {
          this.accessPointChanged.push({
            type: "entry_gate",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
          });
          this.useraccessPointChanged.push({
            type: "entry_gate",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: true,
          });
        }
        if (selected == false) {
          this.accessPointChanged.splice(i, 1);
          this.useraccessPointChanged.push({
            type: "entry_gate",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: false,
          });
          // this.accessPointChanged.push(data);
        }
        console.log('ebtry', this.entryGate);
      } else if (module == 'meetingRoomAccess') {
        let index = this.meetingRoomAccess.indexOf(data);
        data.selected = !data.selected;
        this.meetingRoomAccess[index] = data;
        if (data.selected == true) {
          this.accessPointChanged.push({
            type: "meeting_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
          });
          this.useraccessPointChanged.push({
            type: "meeting_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: true,
          });
        }
        if (data.selected == false) {
          this.accessPointChanged.splice(i, 1);
          this.useraccessPointChanged.push({
            type: "meeting_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: false,
          });
        }
        console.log('ebtry', this.entryGate);
      } else if (module == 'deskAccess') {
        let index = this.deskAccess.indexOf(data);
        data.selected = !data.selected;
        this.deskAccess[index] = data;
        if (data.selected == true) {
          this.accessPointChanged.push({
            type: "desk",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
          });
          this.useraccessPointChanged.push({
            type:"desk",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: true,
          });
        }
        if (data.selected == false) {
          this.accessPointChanged.splice(i, 1);
          this.useraccessPointChanged.push({
            type: "desk",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: false,
          });
        }
        console.log('ebtry', this.entryGate);
      } else if (module == 'privateSuiteAccess') {
        let index = this.privateSuiteAccess.indexOf(data);
        data.selected = !data.selected;
        this.privateSuiteAccess[index] = data;
        if (data.selected == true) {
          this.accessPointChanged.push({
            type: "team_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
          });
          this.useraccessPointChanged.push({
            type: "team_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: true,
          });
        }
        if (data.selected == false) {
          this.accessPointChanged.splice(i, 1);
          this.useraccessPointChanged.push({
            type: "team_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: false,
          });
        }
        console.log('ebtry', this.entryGate);
      }

      if (updateType == 'single') this.updateUserAccessPoint();
    }
  }
  toggleActivationSelection(show) {
    this.activation = !this.activation;
    this.statusText = (this.activation ? "Activate" : "Deactivate");
    if (!this.activation) {
      this.open(this.content);

    }
  }
  revokeAccess(type: string) {
    console.log('employeeDetails', this.employeeDetails, 'type', type);

    switch (type) {
      case 'activation':
        this.adminSrv
          .changeActivation(
            this.activation,
            this.employeeDetails.userId
          )
          .subscribe((response) => {
            console.log('response in component', response);
            // window.location.reload();
            this.modalService.dismissAll();
          });
        break;
      case 'privilege':
        break;
    }
  }
  onCancel(module) {
    if (module == 'activation') {
      this.toggleActivationSelection(this.activation);
    } else {
      this.togglePriviledgeSelection(this.priviledge);
    }
    // this.activation=!this.activation;
  }
  togglePriviledgeSelection(show) {
    this.priviledge = !this.priviledge;
    if (!this.priviledge) {
      this.open(this.contentPriviledge);
    }
  }
  toggleSelectAllSelection(show) {

    let temp = {
      type: '',
      accessPointId: null,
      createdBy: null,
      hasAccess: false,
    };
    let allList = [];
    if (this.selectAll) {
      this.entryGate.forEach((data, index) => {
        data.selected = false;
        temp = {
          type: "entry_gate",
          accessPointId: data.accessPointId,
          createdBy: data.createdBy,
          hasAccess: true,
        };
        allList.push(temp);
        this.changeAccess(data, 'entryGate', index, 'all');
      });
      this.meetingRoomAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = false;
          temp = {
            type: "meeting_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: true,
          };
          allList.push(temp);
          this.changeAccess(data, 'meetingRoomAccess', index, 'all');
        }
      });
      this.deskAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = false;
          temp = {

            type: "desk",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: true,
          };
          allList.push(temp);
          this.changeAccess(data, 'deskAccess', index, 'all');
        }
      });
      this.privateSuiteAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = false;
          temp = {
            type:  "team_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: true,
          };
          allList.push(temp);
          this.changeAccess(data, 'privateSuiteAccess', index, 'all');
        }
      });
    } else {
      this.entryGate.forEach(
        (data, index) => {
          if (!data.isCLAModified) {
            data.selected = true;
            temp = {
              type: "entry_gate",
              accessPointId: data.accessPointId,
              createdBy: data.createdBy,
              hasAccess: false,
            };
            allList.push(temp);
            this.changeAccess(data, 'entryGate', index, 'all');
          }
        }
        // item => item.selected = true
      );
      this.meetingRoomAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = true;
          temp = {
            type: "meeting_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: false,
          };
          allList.push(temp);
          this.changeAccess(data, 'meetingRoomAccess', index, 'all');
        }
      });
      this.deskAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = true;
          temp = {
            type: "desk",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: false,
          };
          allList.push(temp);
          this.changeAccess(data, 'deskAccess', index, 'all');
        }
      });
      this.privateSuiteAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = true;
          temp = {
            type: "team_room",
            accessPointId: data.accessPointId,
            createdBy: data.createdBy,
            hasAccess: false,
          };
          allList.push(temp);
          this.changeAccess(data, 'privateSuiteAccess', index, 'all');
        }
      });
    }
    console.log('useraccessPointChanged', this.useraccessPointChanged);

    this.updateUserAccessPoint(allList);
  }
  addEmployee() {
    this.router.navigate(['/employees/employees-list/add-employees']);
  }


  dateToTimeStamp(date) {
    return Date.parse(date.year + '-' + date.month + '-' + date.day);
  }

  sendObject(date) {
    var obj = {
      year: date.split('-')[2],
      month: date.split('-')[1],
      day: date.split('-')[0],
    };
    return obj;
  }

  navigateToReportsWithFilter(e, type: number) {
    e.preventDefault();
    let fromDate = '';
    let toDate = '';
    switch (type) {
      case 0:
        if (this.creditFromDate == undefined ||this.creditFromDate=='') {
          this.creditFromDateErr = true;
        } else {
          this.creditFromDateErr = false;
        }
        if (this.creditToDate == undefined  ||this.creditToDate=='') {
          this.creditToDateErr = true;
        } else {
          this.creditToDateErr = false;
        }

        if (this.creditFromDateErr || this.creditToDateErr) return;
        if (
          this.dateToTimeStamp(this.sendObject(this.creditFromDate)) > new Date().getTime() ||
          this.dateToTimeStamp(this.sendObject(this.creditToDate)) > new Date().getTime()
        ) {
          this.creditFromDate='';
          this.creditToDate='';
          this.appStateSrv.showToast('Date cannot be future date.');
          return;
        }
        if (
          this.dateToTimeStamp(this.sendObject(this.creditFromDate)) >
          this.dateToTimeStamp(this.sendObject(this.creditToDate))
        ) {
          this.creditFromDate='';
          this.creditToDate='';
          this.appStateSrv.showToast(
            'From date should not be greater than to date'
          );

          return;
        }
        // fromDate =
        //   this.creditFromDate.month +
        //   '/' +
        //   this.creditFromDate.day +
        //   '/' +
        //   this.creditFromDate.year;
        // toDate =
        //   this.creditToDate.month +
        //   '/' +
        //   this.creditToDate.day +
        //   '/' +
        //   this.creditToDate.year;

        fromDate =
        this.creditFromDate.split('-')[1] +
        '/' +
        this.creditFromDate.split('-')[0] +
        '/' +
        this.creditFromDate.split('-')[2];
      toDate =
        this.creditToDate.split('-')[1] +
        '/' +
        this.creditToDate.split('-')[0] +
        '/' +
        this.creditToDate.split('-')[2];

        break;
      case 1:
        if (this.accessFromDate == undefined ||this.accessFromDate=='') {
          this.accessFromDateErr = true;
        } else {
          this.accessFromDateErr = false;
        }
        if (this.accessToDate == undefined ||this.accessToDate=='') {
          this.accessToDateErr = true;
        } else {
          this.accessToDateErr = false;
        }
        if (this.accessFromDateErr || this.accessToDateErr) return;
        if (
          this.dateToTimeStamp(this.sendObject(this.accessFromDate)) > new Date().getTime() ||
          this.dateToTimeStamp(this.sendObject(this.accessToDate)) > new Date().getTime()
        ) {
          this.accessFromDate='';
          this.accessToDate='';
          this.appStateSrv.showToast('Date cannot be future date.');
          return;
        }
        if (
          this.dateToTimeStamp(this.sendObject(this.accessFromDate)) >
          this.dateToTimeStamp(this.sendObject(this.accessToDate))
        ) {
          this.accessFromDate='';
          this.accessToDate='';
          this.appStateSrv.showToast(
            'From date should not be greater than to date'
          );

          return;
        }
        // fromDate =
        //   this.accessFromDate.month +
        //   '/' +
        //   this.accessFromDate.day +
        //   '/' +
        //   this.accessFromDate.year;
        // toDate =
        //   this.accessToDate.month +
        //   '/' +
        //   this.accessToDate.day +
        //   '/' +
        //   this.accessToDate.year;
        fromDate =
        this.accessFromDate.split('-')[1] +
        '/' +
        this.accessFromDate.split('-')[0] +
        '/' +
        this.accessFromDate.split('-')[2];
      toDate =
        this.accessToDate.split('-')[1] +
        '/' +
        this.accessToDate.split('-')[0] +
        '/' +
        this.accessToDate.split('-')[2];
        break;
      case 3:
        if (this.meetingFromDate == undefined ||this.meetingFromDate=='') {
          this.meetingFromDateErr = true;
        } else {
          this.meetingFromDateErr = false;
        }
        if (this.meetingToDate == undefined  ||this.meetingToDate=='') {
          this.meetingToDateErr = true;
        } else {
          this.meetingToDateErr = false;
        }
        if (this.meetingFromDateErr || this.meetingToDateErr) return;

        if (
          this.dateToTimeStamp(this.sendObject(this.meetingFromDate)) >
          this.dateToTimeStamp(this.sendObject(this.meetingToDate))
        ) {
          this.meetingFromDate='';
          this.meetingToDate='';
          this.appStateSrv.showToast(
            'From date should not be greater than to date'
          );

          return;
        }

        // fromDate =
        //   this.meetingFromDate.month +
        //   '/' +
        //   this.meetingFromDate.day +
        //   '/' +
        //   this.meetingFromDate.year;
        // toDate =
        //   this.meetingToDate.month +
        //   '/' +
        //   this.meetingToDate.day +
        //   '/' +
        //   this.meetingToDate.year;

        fromDate =
        this.meetingFromDate.split('-')[1] +
        '/' +
        this.meetingFromDate.split('-')[0] +
        '/' +
        this.meetingFromDate.split('-')[2];
      toDate =
        this.meetingToDate.split('-')[1] +
        '/' +
        this.meetingToDate.split('-')[0] +
        '/' +
        this.meetingToDate.split('-')[2];

        break;
    }
    const queryParams = {
      type: type,
      fromDate: fromDate,
      toDate: toDate,
      select: localStorage.getItem(AppConstant.localStorage.selectedMember),
    };
    console.log('queryParams', queryParams);

    localStorage.setItem('reportQuery', JSON.stringify(queryParams));
    this.router.navigate(['/reports']);
  }
  get today() {
    return this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
  }

  convertMonth;

  convertDateFormat(date){
    console.log(date)
    if(date!==null)
    return this.dateSrv.convertDateToLocaleString(date.split('-')[0],date.split('-')[1]-1,date.split('-')[2])
    }
}
